module.exports = "/_next/static/images/fly_emirates-ce63050d071685dfa62f3123d05be483.svg";